import { render, staticRenderFns } from "./TravelConsent.vue?vue&type=template&id=535d8525&scoped=true&"
import script from "./TravelConsent.vue?vue&type=script&lang=js&"
export * from "./TravelConsent.vue?vue&type=script&lang=js&"
import style0 from "./TravelConsent.vue?vue&type=style&index=0&id=535d8525&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535d8525",
  null
  
)

export default component.exports